import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { DateTime } from 'luxon';
import { map } from 'rxjs/operators';
import { IAppointment } from 'shared/interfaces/appointment.interface';

@Injectable({ providedIn: 'root' })
export class AppointmentService {
	constructor(private httpClient: HttpClient) {}

	getPromptuaries(
		clientId: string,
		limit: string,
		filter: 'by_all' | 'by_me' | 'by_others' | null = null
	) {
		const serviceUrl = environment.servicesUrl;
		let queryParams = new HttpParams();
		queryParams = queryParams.append('profileId', clientId);
		queryParams = queryParams.append('limit', limit);
		queryParams = queryParams.append('skip', '0');
		if (filter !== null) {
			queryParams = queryParams.append('onlyRegistered', true);
		}

		if (filter !== 'by_all' && filter !== null) {
			queryParams = queryParams.append(
				'registeredBy',
				filter === 'by_me' ? 'me' : 'others'
			);
		}

		return this.httpClient
			.get<{ items: IAppointment[]; total: number }>(
				serviceUrl + '/promptuary/appointment/promptuary',
				{ params: queryParams }
			)
			.pipe(
				map((request) => {
					return {
						items: request.items.map((item) => this.checkAppoitmentData(item)),
						total: request.total,
					};
				})
			);
	}

	generateReceipt(eventId: string) {
		const data = { requiredByProfessional: true };
		return this.httpClient.post<any>(
			`appointments/${eventId}/generateReceipt`,
			data
		);
	}

	setSessionReasons(eventId: string, reasonIds: string[]) {
		return this.httpClient.post<any>(
			`appointments/${eventId}/confirmEventFinish`,
			{ contactReason: reasonIds }
		);
	}

	setNoshow(eventId: string, status: boolean, reasonId?: string) {
		return this.httpClient.patch<any>(`appointments/noshow/${eventId}`, {
			noShow: status,
			noShowReasonId: reasonId || null,
		});
	}

	getData(eventId: string) {
		return this.httpClient
			.get<IAppointment>(`appointments/${eventId}`)
			.pipe(map((appointment) => this.checkAppoitmentData(appointment)));
	}

	private checkAppoitmentData(appointment: IAppointment): IAppointment {
		appointment.sessionInFuture =
			DateTime.fromISO(appointment.day) > DateTime.now();
		appointment.notEditable =
			DateTime.now()
				.diff(DateTime.fromISO(appointment.day), ['days'])
				.toObject().days > 7;

		return appointment;
	}

	getLastReasonsForAppointment(appointmentId: string) {
		return this.httpClient
			.get<any>(`appointments/lastSessionReasons/${appointmentId}`)
			.pipe(
				map(({ sessionReasons }) => {
					return sessionReasons;
				})
			);
	}
}
